import { createResource } from '../utils/resource'

const vehicleStore = createResource('vehicle', {})

export default vehicleStore
